import React, { useState, useEffect } from "react";
import { APIURL } from "../../../Config";
import axios from "axios";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { Formik, Form, Field, ErrorMessage } from "formik";

import { toast } from "react-toastify";
import { useRef } from "react";

function AssuranceAgreement() {
  const token = localStorage.getItem("token");
  const emailid = localStorage.getItem("emailId");
  console.log("emailid::: ", emailid);
  const workspaceId = localStorage.getItem("workspace");

  const [workSpace, setWorkSpace] = useState([]);
  console.log("workSpace::: ", workSpace);
  const [isLoader, setIsLoader] = useState(false);
  const [agreementContent, setAgreementContent] = useState("");
  const [activeTab, setActiveTab] = useState("sign");
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [isChecked, setIsChecked] = useState(true);
  const [tncSign, setTncSign] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [todayDate, setTodayDate] = useState("");
  const [deviceID, setDeviceID] = useState(null);
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
  });
  const [address, setAddress] = useState("");
  const otpBoxReference = useRef([]);
  function handleBackspaceAndEnter(e, index) {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      otpBoxReference.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < 5) {
      otpBoxReference.current[index + 1].focus();
    }
  }

  const generateDeviceID = () => {
    let deviceID = localStorage.getItem("deviceID");
    if (!deviceID) {
      deviceID = `device-${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem("deviceID", deviceID);
    }
    return deviceID;
  };
  useEffect(() => {
    getLocation(setLocation);
    const id = generateDeviceID();
    setDeviceID(id);
    const date = new Date();
    setTodayDate(date);
  }, []);

  function handleChange(value, index) {
    let newArr = [...otp];
    newArr[index] = value;
    setOtp(newArr);

    if (value && index < 5) {
      otpBoxReference.current[index + 1].focus();
    }
  }

  const getLocation = (setLocation) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          console.log(latitude);
          setLocation({ latitude, longitude });
        },
        (error) => {
          console.error("Error obtaining location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };
  const handleSubmit = () => {
    console.log("isChecked::: ", isChecked);
    if (isChecked) {
      setIsLoader(true);
      axios
        .request(`${APIURL}/sendOTPtc/${workSpace?.email}`, {
          method: "GET",
        })
        .then((response) => {
          console.log("response", response);
          setIsLoader(false);
          if (response) {
            toast.success("OTP sent successfully");
            setIsChecked(false);
            setShowOtp(true);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setIsLoader(false);
        });
    } else {
      toast.warning("Please check the box before submitting.");
    }
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  useEffect(() => {
    WorkspaceDetails();
  }, []);

  useEffect(() => {
    if (workSpace.email) {
      fetchAgreementContent();
    }
  }, [workSpace]);

  function WorkspaceDetails() {
    const data = { emailid, workspaceId };

    setIsLoader(true);

    axios
      .post(`${APIURL}/corporate/getprofiledetails`, data, {
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setWorkSpace(response?.data);
        setActiveTab(response?.data.assuranceTc ? "view" : "sign");
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoader(false);
      });
  }

  function fetchAgreementContent() {
    setIsLoader(true);
    const url = `${APIURL}/downloadAssurance/${workSpace.corpadminmail}`;
    axios
      .get(url, {
        headers: {
          Authentication: token,
        },
        responseType: "blob",
      })
      .then((response) => {
        const fileURL = URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        );
        setAgreementContent(fileURL);
      })
      .catch((error) => {
        console.error("Error fetching the agreement content:", error);
      })
      .finally(() => {
        setIsLoader(false);
      });
  }
  const handleClose = () => {
    setIsChecked(false);
    setShowAgreementModal(false);
    setShowOtp(false);
  };

  return (
    <div className="p-md-3 pt-3">
      <ul className="nav nav-tabs" id="myTabs" role="tablist">
        {!workSpace?.assuranceTc ? (
          <>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link tab-item ${
                  activeTab === "sign" ? "active" : ""
                }`}
                id="sign-tab"
                data-bs-toggle="tab"
                type="button"
                role="tab"
                onClick={() => setActiveTab("sign")}
              >
                Sign Assurance Agreement
              </button>
            </li>
          </>
        ) : (
          <>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link tab-item ${
                  activeTab === "view" ? "active" : ""
                }`}
                id="view-tab"
                data-bs-toggle="tab"
                type="button"
                role="tab"
                onClick={() => setActiveTab("view")}
              >
                View Agreement
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link tab-item ml-2"
                onClick={(e) => {
                  e.preventDefault();
                  const url = `${APIURL}/downloadAssurance/${workSpace.corpadminmail}`;
                  window.open(url, "_blank");
                }}
                style={{
                  cursor: "pointer",
                  color: "white",
                  backgroundColor: "#28a745",
                  border: "none",
                  borderRadius: "4px",
                  padding: "6px 12px",
                }}
              >
                Download Assurance Agreement
              </button>
            </li>
          </>
        )}
      </ul>

      <div className="tab-content mt-3" id="tabContent">
        {activeTab === "view" && (
          <div className="tab-pane fade show active" id="view-tab-panel">
            {isLoader ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "50vh" }}
              >
                <div className="spinner-border text-success" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : workSpace?.assuranceTc ? (
              <iframe
                src={agreementContent}
                style={{ width: "100%", height: "100vh", border: "none" }}
                title="Agreement Content"
              />
            ) : (
              <p>No agreement found.</p>
            )}
          </div>
        )}

        {activeTab === "sign" && (
          <div className="tab-pane fade show active" id="sign-tab-panel">
            {/* Replace this with actual signing component or form */}
            {!workSpace?.assuranceTc ? (
              // workSpace?.companyType !== null &&
              // workSpace?.hrApp !== null &&
              <>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (!workSpace?.assuranceTc) {
                      setShowAgreementModal(true);
                    }
                  }}
                >
                  Sign Assurance Agreement
                </button>
              </>
            ) : (
              <>
                <h5>Complete Your Profile</h5>{" "}
              </>
            )}
            <div style={{ width: "80%", height: "100%" }}>
              <Modal
                show={showAgreementModal}
                onHide={handleClose}
                size="lg"
                style={{ background: "#ffffffd1" }}
              >
                <div className="px-3">
                  <Modal.Header closeButton>
                    <Modal.Title style={{ color: "#66a725" }}>
                      Assurance Agreement
                    </Modal.Title>
                  </Modal.Header>
                </div>
                <Modal.Body>
                  <div className="px-3">
                    <h3
                      className="mt-2"
                      style={{ fontSize: "18px", fontWeight: "700" }}
                    >
                      TRIPARTITE ASSURANCE AGREEMENT
                    </h3>
                    <h3
                      className="mt-2"
                      style={{ fontSize: "18px", fontWeight: "700" }}
                    >
                      This Tripartite Assurance Agreement ("Agreement") is made
                      on this {moment(todayDate).format("DD")} day of{" "}
                      {moment(todayDate).format("MMMM")},{" "}
                      {moment(todayDate).format("YYYY")} by and among:
                    </h3>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      Ontap Technologies Pvt. Limited (Ontap), a company
                      incorporated under the laws of India, having its
                      registered office at Khasra No. 850, Village Bhati Khurd,
                      New Delhi – 110074 (hereinafter referred to as "Ontap",
                      which expression shall, unless repugnant to the context or
                      meaning thereof, be deemed to include its successors and
                      assigns),
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      {workSpace?.companyName}, a company/firm
                      incorporated/registered under the laws of India, having
                      its registered office at {workSpace?.address || address}{" "}
                      (hereinafter referred to as the "Business Owner", which
                      expression shall, unless repugnant to the context or
                      meaning thereof, be deemed to include its successors and
                      assigns), and
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      Capital Trust Limited (CTL), a company incorporated under
                      the laws of India and an RBI-registered NBFC, having its
                      registered office at 205 Centrum Mall, Mehrauli-Gurgaon
                      Road, Sultanpur, New Delhi – 110030 (hereinafter referred
                      to as the "Funder", which expression shall, unless
                      repugnant to the context or meaning thereof, be deemed to
                      include its successors and assigns).
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      (Each a "Party" and collectively the "Parties")
                    </h6>

                    <h5
                      className="mt-3"
                      style={{ fontSize: "18px", fontWeight: "500" }}
                    >
                      WHEREAS:
                    </h5>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      A. Ontap operates a technology platform known as
                      CashOnTap, which facilitates Digital credit line services
                      for business associates via partnerships with business
                      owners and NBFCs.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      B. The Funder extends financial credit to associates of
                      the business owner through the CashOnTap platform for
                      credit line disbursements, under pre-agreed terms.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      C. The business owner desires to partner with Ontap and
                      the Funder to facilitate credit line access for its
                      associates.
                    </h6>

                    <h3
                      className="mt-4"
                      style={{ fontSize: "19px", fontWeight: "700" }}
                    >
                      NOW, THEREFORE, in consideration of the mutual covenants
                      and promises set forth herein, the Parties agree as
                      follows:
                    </h3>

                    <h5
                      className="mt-4"
                      style={{ fontSize: "18px", fontWeight: "500" }}
                    >
                      1. DEFINITIONS
                    </h5>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      1.1. Associates/Business Associates means a
                      supplier/buyer/service provider of the business owner who
                      avails of the credit line facility through the CashOnTap
                      platform.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      1.2. Outstanding Amount means the total amount availed by
                      the associates from the Funder during a particular
                      calendar month, including any applicable fees as
                      communicated.
                    </h6>

                    <h5
                      className="mt-3"
                      style={{ fontSize: "18px", fontWeight: "500" }}
                    >
                      2. ROLE AND OBLIGATIONS OF THE Business Owner
                    </h5>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      2.1. The Business Owner shall be responsible for payment
                      of the total Outstanding Amount for each participating
                      Associates if they do not pay by end of the month.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      2.2. The Business Owner shall remit the total Outstanding
                      Amount to the Funder on or before the 7th day of each
                      month, without delay or demur.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      2.3. The Business Owner acknowledges that the Associates's
                      access to future credit line shall be conditional on full
                      repayment of the previous month's Outstanding Amount. The
                      Funder shall not extend further credit to the Associates
                      unless the repayment is made in full.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      2.4. In the event the Business Owner chooses to disburse
                      credit line using its own funds, instead of those of the
                      Funder, the Business Owner shall pay Ontap a fee
                      equivalent to 0.5% of every withdrawal made by each
                      Associates, as a Software-as-a-Service (SaaS) charge.
                    </h6>

                    <h5
                      className="mt-3"
                      style={{ fontSize: "18px", fontWeight: "500" }}
                    >
                      3. ROLE AND OBLIGATIONS OF THE FUNDER
                    </h5>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      3.1. The Funder shall extend credit lines to Associatess
                      in accordance with applicable agreements, based on
                      Business Owner confirmation and platform data.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      3.2. Upon receipt of the monthly Outstanding Amount from
                      the Business Owner, the Funder shall reinstate the credit
                      limit for each Associates for the next month.
                    </h6>

                    <h5
                      className="mt-3"
                      style={{ fontSize: "18px", fontWeight: "500" }}
                    >
                      4. ROLE AND OBLIGATIONS OF ONTAP
                    </h5>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      4.1. Ontap shall operate and maintain the CashOnTap
                      platform to facilitate Associates onboarding, salary
                      advance tracking, and reporting.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      4.2. Ontap shall provide the Business Owner with a secure
                      online workspace to upload Associates salary and
                      payroll-related data, unless an API-based integration has
                      been implemented between the Business Owner's systems and
                      Ontap. The workspace shall also enable the Business Owner
                      to access real-time dashboards reflecting Associates-level
                      usage, disbursals, and outstanding balances.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      4.3. In case of Business Owner-funded advances, Ontap
                      shall raise monthly invoices for the applicable 0.5% SaaS
                      fee.
                    </h6>

                    <h5
                      className="mt-3"
                      style={{ fontSize: "18px", fontWeight: "500" }}
                    >
                      5. TERM AND TERMINATION
                    </h5>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      5.1. This Agreement shall remain in force unless
                      terminated by mutual consent or with a prior written
                      notice of 30 days by any Party.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      5.2. Termination shall not affect any liabilities or
                      obligations accrued prior to the date of termination.
                    </h6>

                    <h5
                      className="mt-3"
                      style={{ fontSize: "18px", fontWeight: "500" }}
                    >
                      6. MISCELLANEOUS
                    </h5>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      6.1. Governing Law & Jurisdiction: This Agreement shall be
                      governed by and construed in accordance with the laws of
                      India. The courts of New Delhi shall have exclusive
                      jurisdiction.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      6.2. Amendments: Any amendment to this Agreement shall be
                      made in writing and duly signed by all Parties.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      6.3. Entire Agreement: This Agreement constitutes the
                      entire understanding among the Parties and supersedes all
                      prior understandings, whether oral or written.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      6.4. Counterparts: This Agreement may be executed in
                      counterparts, each of which shall be deemed an original,
                      and all of which together shall constitute one and the
                      same instrument.
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "600", fontSize: "18px" }}
                    >
                      IN WITNESS WHEREOF, the Parties hereto have caused this
                      Agreement to be executed by their duly authorized
                      representatives as of the date first above written.
                    </h6>

                    <h6
                      className="mt-5"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      For Ontap Technologies Pvt. Limited
                    </h6>
                    <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                      (Signature)
                    </h6>
                    <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                      Name:
                    </h6>
                    <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                      Designation:
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      For Business Owner
                    </h6>
                    <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                      (Signature)
                    </h6>
                    <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                      Name:
                    </h6>
                    <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                      Designation:
                    </h6>

                    <h6
                      className="mt-3"
                      style={{ fontWeight: "400", fontSize: "16px" }}
                    >
                      For Capital Trust Limited
                    </h6>
                    <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                      (Signature)
                    </h6>
                    <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                      Name:
                    </h6>
                    <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                      Designation:
                    </h6>
                  </div>
                </Modal.Body>
                {!workSpace?.assuranceTc ? (
                  !showOtp ? (
                    <Modal.Footer className="d-flex justify-content-between">
                      <>
                        <div className="pl-3">
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                            style={{
                              width: "20px",
                              height: "20px",
                              padding: "10px",
                              boxSizing: "border-box",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              fontSize: "18px",
                            }}
                          />
                        </div>
                        <div className="d-flex justify-content-end pr-3">
                          <button
                            className="btn btn-secondary"
                            style={{ width: "100px" }}
                            onClick={handleClose}
                          >
                            Back
                          </button>
                          <button
                            className="btn btn-success ml-2"
                            style={{
                              width: "100px",
                              background: "#66a725",
                            }}
                            onClick={() => handleSubmit()}
                          >
                            Proceed
                          </button>
                        </div>
                      </>
                    </Modal.Footer>
                  ) : (
                    <Modal.Footer className="d-flex justify-content-center">
                      <Formik
                        initialValues={{ email: "" }}
                        // validationSchema={LoginSchema}
                        onSubmit={(values) => {
                          const hasEmptyString = otp.some(
                            (value) => value === ""
                          );
                          if (!hasEmptyString) {
                            const data = {
                              emailid: workSpace?.email,
                              otp: parseInt(otp.join("")),
                              deviceid: deviceID,
                              latitude: location?.latitude,
                              longitude: location?.longitude,
                              address: address,
                            };
                            let config = {
                              method: "post",
                              maxBodyLength: Infinity,
                              url: `${APIURL}/verifyOtp`,
                              headers: {
                                "Content-Type": "application/json",
                                Cookie:
                                  "JSESSIONID=BC3EE2C6CF6BEC78620E768072A47123",
                              },
                              data: data,
                            };

                            setIsLoader(true);
                            axios
                              .request(config)
                              .then((response) => {
                                console.log("response", response);
                                toast.success(response?.data);
                                setIsLoader(false);
                                handleClose();
                                setTncSign(true);
                                window.location.reload();
                              })
                              .catch((error) => {
                                console.log("error", error);
                                setIsLoader(false);
                                toast.warning("Invalid...");
                              });
                          } else {
                            toast.error("All fields required");
                          }
                        }}
                      >
                        {({ touched, errors }) => (
                          <>
                            <Form className=" ">
                              <div>
                                <div>
                                  <div className="mt-2">
                                    <p
                                      style={{
                                        display: "flex",
                                        justifyContent: "start",
                                        fontSize: "16px",
                                        fontWeight: "500",
                                      }}
                                      className=""
                                    >
                                      Enter OTP*
                                    </p>
                                  </div>
                                  <div className="row mt-2">
                                    <div className="col-lg-12 text-center">
                                      <div
                                        className=""
                                        style={{
                                          flexDirection: "row",
                                          columnGap: "10px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "start",
                                        }}
                                      >
                                        {otp.map((digit, index) => (
                                          <input
                                            key={index}
                                            value={digit}
                                            maxLength={1}
                                            onChange={(e) =>
                                              handleChange(
                                                e.target.value,
                                                index
                                              )
                                            }
                                            onKeyUp={(e) =>
                                              handleBackspaceAndEnter(e, index)
                                            }
                                            ref={(reference) =>
                                              (otpBoxReference.current[index] =
                                                reference)
                                            }
                                            style={{
                                              height: "45px",
                                              width: "45px",
                                            }}
                                            className={`border w-12 h-12 text-4xl text-black p-3 rounded-md block bg-light focus:border-2 focus:outline-none appearance-none text-center`}
                                          />
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <button
                                      className="btn btn-success mt-3"
                                      type="submit"
                                      style={{
                                        background: "#66a725",
                                        color: "#fff",
                                      }}
                                    >
                                      {isLoader ? (
                                        <div
                                          className="spinner-border text-success"
                                          role="status"
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      ) : (
                                        "Submit"
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </Form>
                          </>
                        )}
                      </Formik>
                    </Modal.Footer>
                  )
                ) : (
                  ""
                )}
              </Modal>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AssuranceAgreement;
